export default ({theme, fill, border}) => ({
    selectedTheme: theme,
    fill,
    border,
    setTheme(theme) {
        const isSystem = theme === "system";

        const isDark =
            theme === "dark" ||
            (isSystem && window.matchMedia("(prefers-color-scheme: dark)").matches);

        this.selectedTheme = isDark ? 'dark' : 'light';
    },
    get svg() {
       return this.$el.querySelector('svg');
    },
    changeSvgColor() {
        const fill = this.fill[this.selectedTheme];
        const border = this.border[this.selectedTheme];

        const fillPath = this.svg.querySelector('[data-name="fill-path"]');
        const borderPath = this.svg.querySelector('[data-name="border-path"]');

        fillPath.setAttribute('fill', fill);
        borderPath.setAttribute('fill', border);
    },
    init() {
        window.addEventListener('change-appearance-mode', (event) => {
            this.setTheme(event.detail.theme);

            this.changeSvgColor();
        });

        window.addEventListener('system-appearance-mode-changed', (event) => {
            this.setTheme(event.detail.theme);

            this.changeSvgColor();
        });
    }
})
